import { JSONResume } from '../interface/jsonResume';
import Alpine from 'alpinejs';

const CACHE_KEY = 'resume_cache';
const CACHE_TIMESTAMP_KEY = 'resume_cache_timestamp';
const CACHE_MAX_AGE = 60 * 60 * 1000; // 1 timme i millisekunder

interface LoadingStore {
	isLoading: boolean;
}

Alpine.store('loading', {
	isLoading: true,
});

async function main() {
	(Alpine.store('loading') as LoadingStore).isLoading = true;
	var resume = await fetchResumeJson();
	var formattedResume = formatResume(resume);
	setupAlpineJS(formattedResume);
	(Alpine.store('loading') as LoadingStore).isLoading = false;
	Alpine.start();
}

function formatResume(resume: JSONResume): JSONResume {
	console.log('Formatting resume');

	// EG set empty enddate to "ongoing" for work
	// format the list of work.highlights to be comma+space separated (same for intrests)
	return resume;
}


async function fetchResumeJson(): Promise<JSONResume> {
	console.log('Checking for cached resume');

	const cachedData = localStorage.getItem(CACHE_KEY);
	const cachedTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);

	const now = new Date().getTime();
	if (cachedData && cachedTimestamp && now - Number(cachedTimestamp) < CACHE_MAX_AGE) {
		console.log('Loaded resume from cache');
		return JSON.parse(cachedData);
	}

	console.log('Fetching resume JSON from network');
	const response = await fetch('https://api.github.com/gists/2f1784c362aee1de588d32ab060117db');
	const result = await response.json();
	const resume = JSON.parse(result.files['resume.json'].content);

	localStorage.setItem(CACHE_KEY, JSON.stringify(resume));
	localStorage.setItem(CACHE_TIMESTAMP_KEY, now.toString());

	return resume;
}

function setupAlpineJS(resume: JSONResume) {
	console.log('Setting up AlpineJS');

	window.Alpine = Alpine;

	Alpine.store('resume', {
		resume: 'resumeJson',
		basic: resume.basics,
		work: resume.work,
		certificates: resume.certificates,
		volunteer: resume.volunteer,
		education: resume.education,
		awards: resume.awards,
		publications: resume.publications,
		skills: resume.skills,
		languages: resume.languages,
		interests: resume.interests,
		references: resume.references,
		projects: resume.projects,
		meta: resume.meta,
	});

	document.addEventListener('alpine:init', () => {
		Alpine.data('profileHandler', () => ({
			profileImage(profile: string) {
				const profileImageMap = new Map();
				profileImageMap.set('Email', 'icons/mail.webp');
				profileImageMap.set('Website', 'icons/world-wide-web.webp');
				profileImageMap.set('Bitbucket', 'icons/bitbucket.webp');
				profileImageMap.set('Github', 'icons/github.webp');
				profileImageMap.set('LinkedIn', 'icons/linkedin.webp');
				profileImageMap.set('Google Developer', 'icons/google.webp');
				profileImageMap.set('TryHackMe', 'icons/padlock.webp');
				profileImageMap.set(
					'Skillsoft Badges',
					'icons/logical-thinking.webp'
				);
				profileImageMap.set('Microsoft Learn', 'icons/microsoft.webp');
				profileImageMap.set('Default', 'icons/profile.webp');

				if (profileImageMap.has(profile)) {
					console.log(profile + ': ' + profileImageMap.get(profile));

					return profileImageMap.get(profile);
				} else {
					console.log(
						profile + ': ' + profileImageMap.get('Default')
					);

					return profileImageMap.get('Default');
				}
			},
		}));
	});
}

main();
